import React from "react";
import { Box, Text, Link as ChakraLink } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import useCleverTap, {
  ButtonTypes,
  CleverTapEvents,
  ScreenNames,
} from "../../../clevertap/useCleverTap";

interface Props {
  title: string | number;
  type: "primary" | "secondary" | "tab" | "hamburger-label"; // primary | secondary | tab |
  badgeComponent?: React.ReactElement; // completely optional
  iconForPrimary?: React.ReactElement; // required if type is primary
  iconForTab?: React.ReactElement;
  active?: boolean;
  path: string;
  link?: string;
  isExternal?: boolean;
}
const NavigationLabel = ({
  title,
  type,
  badgeComponent: Badge,
  iconForPrimary,
  iconForTab,
  active,
  path,
  link,
  isExternal,
}: Props) => {
  const clevertap = useCleverTap()[0];
  // console.log(title,"titlefghj",type,"typehjkl")
  const activeStyles: {
    bg?: string;
    "& svg"?: {
      color: string;
    };
    color?: string;
    boxShadow?: string;
  } = {
    bg: "ms-blue.50",
    "& svg": {
      color: "ms-blue.500",
    },
    color: "ms-blue.500",
    boxShadow: type === "tab" ? "0px 2px 0px 0px #3470E4 inset" : "4px 0px 0px 0px #3470E4 inset",
  };

  let Icon;
  if (type === "primary") Icon = iconForPrimary;
  else if (type === "tab") Icon = iconForTab;

  let styling = {
    p: "",
    height: "",
    textStyle: "",
    mb: "0",
  };
  switch (type) {
    case "primary":
      styling = {
        p: "16px 8px 16px 24px",
        height: "3.5rem",
        textStyle: "body1-md",
        mb: "0",
      };
      break;
    case "secondary":
      styling = {
        p: "8px 8px 8px 24px",
        height: "2.5rem",
        textStyle: "body2-md",
        mb: "0",
      };
      break;
    case "tab":
      styling = {
        p: "10px 4px 8px 4px",
        height: "3.5rem",
        textStyle: "caption",
        mb: "0",
      };
      break;
    case "hamburger-label":
      styling = {
        p: "8px",
        height: "3.125rem",
        textStyle: "subtitle1",
        mb: "2",
      };
      break;
  }

  const onClickTracker = () => {
    // clever tap
    const btnText = title.toLocaleString().toLowerCase();
    if (type === "primary" || type === "tab") {
      clevertap.fireEvent(CleverTapEvents.click_switch_section, {
        screen_name: ScreenNames.dashboardCourses,
        button_text: btnText,
        button_type: ButtonTypes.link,
        button_sequence:
          btnText === "courses"
            ? 1
            : btnText === "contests"
            ? 2
            : btnText === "events"
            ? 3
            : btnText === "self learning"
            ? 4
            : 0,
        bottom_navigation: type === "tab" ? true : false,
      });
    } else {
      clevertap.fireEvent(CleverTapEvents.click_dashboard_navigation_tab, {
        screen_name: ScreenNames.dashboardCourses,
        button_text: btnText,
        button_type: ButtonTypes.link,
        button_sequence:
          btnText === "referral program" ? 1 : btnText === "isa" ? 2 : btnText === "faqs" ? 3 : 0,
        hamburger: type == "hamburger-label" ? true : false,
      });
    }
  };

  const NavItem = (
    <Box
      {...styling}
      w={"100%"}
      d={"flex"}
      alignItems={"center"}
      active={true}
      _hover={activeStyles}
      sx={active && type !== "hamburger-label" ? { ...activeStyles } : {}}
      cursor={"pointer"}
      flexDirection={type == "tab" ? "column" : "row"}
      mb={styling.mb}
      border="hidden"
    >
      {/* Render if type is primary ||  type is tab */}
      {type === "primary" || type === "tab" ? (
        <Box mr={type === "tab" ? 0 : 2} mb={type === "tab" ? 1 : 0} boxSize={6}>
          {Icon &&
            React.cloneElement(Icon, {
              boxSize: 6,
            })}
        </Box>
      ) : null}
      {/* render title  */}
      <Text textStyle={styling.textStyle}>{title}</Text>
      {/* Render if badge is provided */}
      {Badge && <Box ml={2}>{Badge}</Box>}
    </Box>
  );

  return (
    <>
      {isExternal ? (
        <ChakraLink isExternal href={link} onClick={onClickTracker}>
          {NavItem}
        </ChakraLink>
      ) : (
        <Link onClick={onClickTracker} to={path}>
          {NavItem}
        </Link>
      )}
    </>
  );
};

export default NavigationLabel;
